export const MANUAL_JOURNAL_ENTRY_API = (COMMUNITY_ID: string) =>  `v1/community/${COMMUNITY_ID}/mje`;
export const AUDIT_API = (COMMUNITY_ID: string) =>  `v1/community/${COMMUNITY_ID}/uje/audit`;